// Success.jsx

import React, { useRef, useState } from "react";
import "./success.css";
import bilyard from '../../assets/bilyard.mp4'

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import { FaPlay } from "react-icons/fa6";
import { FaPause } from "react-icons/fa";


import "swiper/css";
import "swiper/css/navigation";

const videos = [
  {
    id: 1,
    video: bilyard,
    name: "Esther Howard",
    desc: "Frontend kursi haqida",
  },

  {
    id: 2,
    video: bilyard,
    name: "John Carter",
    desc: "React kursi haqida",
  },

  {
    id: 3,
    video: bilyard,
    name: "Michael Lee",
    desc: "JavaScript kursi haqida",
  },
   {
    id: 4,
    video: bilyard,
    name: "Esther Howard",
    desc: "Frontend kursi haqida",
  },

  {
    id: 5,
    video: bilyard,
    name: "John Carter",
    desc: "React kursi haqida",
  },

  {
    id: 6,
    video: bilyard,
    name: "Michael Lee",
    desc: "JavaScript kursi haqida",
  },
];

const Success = () => {
  const videoRefs = useRef([]);
  const [playingIndex, setPlayingIndex] = useState(null);

  // PLAY VIDEO
  const handlePlay = async (index) => {
    videoRefs.current.forEach((video, i) => {
      if (video && i !== index) {
        video.pause();
        video.currentTime = 0;
      }
    });

    const currentVideo = videoRefs.current[index];

    if (currentVideo.paused) {
      await currentVideo.play();
      setPlayingIndex(index);
    } else {
      currentVideo.pause();
      setPlayingIndex(null);
    }
  };

  // SWIPER O‘ZGARGANDA STOP
  const stopAllVideos = () => {
    videoRefs.current.forEach((video) => {
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });

    setPlayingIndex(null);
  };

  return (
    <div className="success">
      <h1>O‘quvchilar muvaffaqiyati</h1>

      <Swiper 
      // style={{padding: '50px'}}
        modules={[Navigation]}
        slidesPerView={3}
        spaceBetween={30}
        navigation
        loop={true}
        onSlideChange={stopAllVideos}
        breakpoints={{
          0: {
            slidesPerView: 1,
          },

          768: {
            slidesPerView: 2,
          },

          1100: {
            slidesPerView: 3,
          },
        }}
        className="mySwiper"
      >
        {videos.map((item, index) => (
          <SwiperSlide key={item.id} className="sw-cont-card">
            <div className="card">
              <video
                ref={(el) => (videoRefs.current[index] = el)}
                src={item.video}
                className="video"
              />

              <div className="overlay">
                <div>
                  <h2>{item.name}</h2>
                  <p>{item.desc}</p>
                </div>

                <button
                  className={`playBtn ${
                    playingIndex === index ? "active" : ""
                  }`}
                  onClick={() => handlePlay(index)}
                >
                  {playingIndex === index ? <FaPause />
 : <FaPlay />
}
                </button>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Success;